/**
 * Centralized slug normalization mapping for breadcrumb links and server redirects
 *
 * This mapping is used to normalize various rental search slugs to their base equivalents:
 * - Most slugs normalize to 'apartments-for-rent'
 * - House-related slugs normalize to 'houses-for-rent'
 */
export const SLUG_NORMALIZATION_MAP = {
  // Apartment-related slugs
  'studio-apartments-for-rent': 'apartments-for-rent',
  '1-bedroom-apartments-for-rent': 'apartments-for-rent',
  '2-bedroom-apartments-for-rent': 'apartments-for-rent',
  '3-bedroom-apartments-for-rent': 'apartments-for-rent',
  'pet-friendly-apartments-for-rent': 'apartments-for-rent',
  'furnished-apartments-for-rent': 'apartments-for-rent',
  'apartments-for-rent-with-laundry': 'apartments-for-rent',
  'apartments-for-rent-with-parking': 'apartments-for-rent',
  'apartments-for-rent-with-gym': 'apartments-for-rent',
  'apartments-for-rent-with-pool': 'apartments-for-rent',
  'apartments-for-rent-with-gated-entry': 'apartments-for-rent',
  'cheap-apartments-for-rent': 'apartments-for-rent',
  'luxury-apartments-for-rent': 'apartments-for-rent',
  'new-apartments-for-rent': 'apartments-for-rent',
  'loft-apartments-for-rent': 'apartments-for-rent',

  // Other property types that normalize to apartments
  'for-rent-by-owner': 'apartments-for-rent',
  'condos-for-rent': 'apartments-for-rent',
  'townhomes-for-rent': 'apartments-for-rent',
  'townhomes-for-rent-by-owner': 'apartments-for-rent',
  'apartments-and-condos-for-rent-by-owner': 'apartments-for-rent',
  'rooms-for-rent': 'apartments-for-rent',

  // House-related slugs
  '1-bedroom-houses-for-rent': 'houses-for-rent',
  '2-bedroom-houses-for-rent': 'houses-for-rent',
  '3-bedroom-houses-for-rent': 'houses-for-rent',
  '4-plus-bedroom-houses-for-rent': 'houses-for-rent',
  'pet-friendly-houses-for-rent': 'houses-for-rent',
  'furnished-houses-for-rent': 'houses-for-rent',
  'cheap-houses-for-rent': 'houses-for-rent',
  'luxury-houses-for-rent': 'houses-for-rent',
  'new-houses-for-rent': 'houses-for-rent',
  'houses-for-rent-by-owner': 'houses-for-rent',
  'senior-housing-houses-for-rent': 'houses-for-rent',
} as const;

/**
 * Base rental slug constants
 */
export const BASE_RENTAL_SLUGS = {
  APARTMENTS: 'apartments-for-rent',
  HOUSES: 'houses-for-rent',
} as const;
